import axios from 'axios';
import * as actionTypes from './actionTypes';

export const authInit = () => {
    return{
        type: actionTypes.AUTH_INIT
    }
}
const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    }
}

const authSuccess = (token, userId, username) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        token,
        userId,
        username
    }
}

const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error
    }
}

const addUserToFirebase = (userId, email, username, token) => {
    const url = "https://hackernewsclone-9d286-default-rtdb.firebaseio.com/users/" + userId + ".json"
    const userData = {
        email,
        username,
        createdOn: new Date()
    }
    axios
        .put(url + "?auth=" + token, userData)
        .then(response => {
            //console.log(response)
        })
        .catch(error => {
            console.log(error)
        })
}

export const auth = (email, password, isSignup) => {
    return (dispatch) => {
        dispatch(authStart())
        const authData = {
            email,
            password,
            returnSecureToken: true
        }
        const api = "AIzaSyAH7nn7k6OsfKPrFwnvjXb7Z3c9HKW1kR4"
        let url = "https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=";
        if (!isSignup) {
            url =
                "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=";
        }
        axios
            .post(url + api, authData)
            .then((response) => {
                const expirationDate = new Date(
                    new Date().getTime() + response.data.expiresIn * 1000
                );
                const token = response.data.idToken
                const email = response.data.email;
                const username = email.split('@')[0];
                const userId = response.data.localId;

                localStorage.setItem("token", token);
                localStorage.setItem("expirationDate", expirationDate);
                localStorage.setItem("userId", userId);
                localStorage.setItem("username", username);

                if (isSignup) addUserToFirebase(userId, email, username, token)

                dispatch(authSuccess(token, userId, username));
                dispatch(checkAuthTimeout(response.data.expiresIn));
            })
            .catch((error) => {
                console.log(error.response)
                dispatch(authFail(error.response.data.error.message));
            });
    };
}

export const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("expirationDate");
    localStorage.removeItem("userId");
    localStorage.removeItem("username");
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};

const checkAuthTimeout = (expirationTime) => {
    return (dispatch) => {
        setTimeout(() => {
            dispatch(logout());
        }, expirationTime * 1000);
    };
};

export const authCheckState = () => {
    return (dispatch) => {
        const token = localStorage.getItem("token");
        if (token) {
            const expirationDate = new Date(localStorage.getItem("expirationDate"));
            if (expirationDate > new Date()) {
                const userId = localStorage.getItem("userId");
                const username = localStorage.getItem("username");
                dispatch(authSuccess(token, userId, username));
                dispatch(
                    checkAuthTimeout(
                        (expirationDate.getTime() - new Date().getTime()) / 1000
                    )
                );
            } else {
                dispatch(logout());
            }
        } else {
            dispatch(logout());
        }
    };
};